export const GET_LOCALIZATION_REQUESTING = 'GET_LOCALIZATION_REQUESTING';
export const GET_LOCALIZATION_REQUEST = 'GET_LOCALIZATION_REQUEST';
export const GET_LOCALIZATION_SUCCESS = 'GET_LOCALIZATION_SUCCESS';
export const RESET_LOCALIZATION_ISFETCHING = 'RESET_LOCALIZATION_ISFETCHING';
